// extracted by mini-css-extract-plugin
export default {"page":"ReportsPage_page__0ilzT","header":"ReportsPage_header__+Z9qU","filters":"ReportsPage_filters__WN85B","vehicleSelect":"ReportsPage_vehicleSelect__KYcu+"};